// extracted by mini-css-extract-plugin
export default {"description":"workflow-details-visualization-tab__description__twpaa"};